import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles, useTheme } from '@material-ui/core/styles'

import {
  Divider,
  Grid,
  Typography
} from '@material-ui/core'

import * as Brands from '~/assets/images/logo/brands'
import Menu from '~/components/menu'

export default () => {
  const classes = useStyles()
  const theme = useTheme()

  const logoColor = theme.palette?.inverse ? theme.palette.primary.main : theme.palette.background.paper

  const { store } = useSelector(state => state.storeReducers)

  const { REACT_APP_BRANCH } = window?.env || {}

  const RenderStoreCampaignInfos = () => {
    if (!store?.storeName) {
      return ''
    }

    return (
      <>
        <Grid item>
          <Divider light={!theme.palette?.inverse} />
        </Grid>
        <Grid item>
          <Grid container direction='row' wrap='nowrap' justify='center' spacing={4}>
            <Grid item>
              <Typography variant='body1' align='center'>
                {store?.storeName}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </>
    )
  }

  return (
    <Grid container direction='row' wrap='nowrap' className={classes.BASE} alignItems='center'>
      <Grid item xs={12} sm={12} md={4} lg={4}>
        <Menu />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} className={classes.LOGO}>
        <Grid container direction='column' wrap='nowrap' spacing={4}>
          <Grid item>
            <Grid container direction='row' wrap='nowrap' justify='center'>
              <Grid item>
                {Brands[REACT_APP_BRANCH] ? Brands[REACT_APP_BRANCH](logoColor) : Brands.BOT(logoColor)}
              </Grid>
            </Grid>
          </Grid>
          <RenderStoreCampaignInfos />
        </Grid>
      </Grid>
    </Grid>
  )
}

const useStyles = makeStyles((theme) => ({
  BASE: {
    ...(
      theme.palette?.inverse ? (
        {
          background: theme.palette.secondary.main,
          color: theme.palette.primary.main
        }
      ) : (
        {
          background: theme.palette.primary.main,
          color: theme.palette.background.paper
        }
      )
    ),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  },
  LOGO: {
    position: 'relative',
    '& svg': {
      height: '30px',
      width: 'auto',
      maxWidth: '100%',
      display: 'block'
    }
  }
}))
